const initialState = {
    clients: []
};

export default (state = initialState, action) => {
    switch(action.type){
        case "clients/LOAD_CLIENTS_SUCCESS":
            return {
                ...state,
                clients: action.payload
            };
        case "clients/LOAD_CLIENTS_ERROR":
            return {
                ...state,
                error: action.payload
            };
        default:
            return state;
    }
};
